import styled from 'styled-components';
import moment from 'moment';
import { DATE_FORMAT } from '../../../utils/constants';
import { getOrderCustomerName } from '~/src/utils/misc';
import TableWrapper from '~/src/components/common/forms/TableWrapper/TableWrapper';
import { Colors } from '~/src/scss/common/style';

export default function InventoryStockTotals({ totals }) {
  const overallTotal = totals.reduce(
    (res, total) => {
      res.totalCuUnits += total.totalCuUnits;
      res.fullDuUnits += total.fullDuUnits || 0;
      res.singleDpUnits += total.singleDpUnits || 0;
      res.singleCuUnits += total.singleCuUnits || 0;

      return res;
    },
    { totalCuUnits: 0, fullDuUnits: 0, singleDpUnits: 0, singleCuUnits: 0 }
  );

  const externalWarehouses = totals.filter((item) => item.isForExternalWarehouse);
  const externalTotalsByOwner = externalWarehouses.reduce((groups, item) => {
    const ownerName = item.warehouseOwner?.name || "Unknown Warehouse";
    if (!groups[ownerName]) {
      groups[ownerName] = { totalCuUnits: 0, fullDuUnits: 0, singleDpUnits: 0, singleCuUnits: 0 };
    }

    groups[ownerName].totalCuUnits += item.totalCuUnits;
    groups[ownerName].fullDuUnits += item.fullDuUnits || 0;
    groups[ownerName].singleDpUnits += item.singleDpUnits || 0;
    groups[ownerName].singleCuUnits += item.singleCuUnits || 0;

    return groups;
  }, {});

  const noOrderItems = totals.filter((item) => item.sellOrder === null);

  const internalWarehouses = totals.filter(
    (item) => !item.isForExternalWarehouse && item.sellOrder !== null
  );

  return (
    <div>
      <TableWrapper>
        <thead>
          <tr>
            <HeaderCell>Order</HeaderCell>
            <HeaderCell>Total Cu</HeaderCell>
            <HeaderCell>Du</HeaderCell>
            <HeaderCell>Single Dp</HeaderCell>
            <HeaderCell>Single Cu</HeaderCell>
          </tr>
        </thead>
        <tbody>

          {internalWarehouses.map((item) => (
            <tr key={item.id}>
              <Cell style={{ textAlign: 'left' }}>
                {`#${item.sellOrder.orderNumber} - ${moment(item.sellOrder.createdOn).format(
                  DATE_FORMAT
                )} - ${getOrderCustomerName(item.sellOrder)}`}
              </Cell>
              <Cell>{item.totalCuUnits}</Cell>
              <Cell>{item.fullDuUnits}</Cell>
              <Cell>{item.singleDpUnits}</Cell>
              <Cell>{item.singleCuUnits}</Cell>
            </tr>
          ))}

          {Object.entries(externalTotalsByOwner).map(([ownerName, totals]) => (
            <tr key={ownerName}>
              <Cell style={{ textAlign: 'left' }}>
                External Warehouse Owner - {ownerName}
              </Cell>
              <Cell>{totals.totalCuUnits}</Cell>
              <Cell>{totals.fullDuUnits}</Cell>
              <Cell>{totals.singleDpUnits}</Cell>
              <Cell>{totals.singleCuUnits}</Cell>
            </tr>
          ))}

          {noOrderItems.map((item) => (
            <tr key={item.id}>
              <Cell style={{ textAlign: 'left' }}>No order</Cell>
              <Cell>{item.totalCuUnits}</Cell>
              <Cell>{item.fullDuUnits}</Cell>
              <Cell>{item.singleDpUnits}</Cell>
              <Cell>{item.singleCuUnits}</Cell>
            </tr>
          ))}

          <tr>
            <HeaderCell style={{ textAlign: 'right' }}>All</HeaderCell>
            <BottomCell style={{ borderBottomLeftRadius: 10 }}>{overallTotal.totalCuUnits}</BottomCell>
            <BottomCell>{overallTotal.fullDuUnits}</BottomCell>
            <BottomCell>{overallTotal.singleDpUnits}</BottomCell>
            <BottomCell style={{ borderBottomRightRadius: 10 }}>{overallTotal.singleCuUnits}</BottomCell>
          </tr>
        </tbody>
      </TableWrapper>
    </div>
  );
}

const Cell = styled.td`
  padding: 5px;
  border: 1px solid #f0f0f0;
  width: 100%;
`;

const HeaderCell = styled.th`
  padding: 5px;
  border: 1px solid #f0f0f0;
  font-weight: bold;
`;

const BottomCell = styled.th`
  padding: 5px;
  border: 1px solid #f0f0f0;
  font-weight: bold;
  background: ${Colors.darkBrown};
  color: #fff !important;
  text-align: center;
`;
